var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);

// db/mail-template.ts
import { A } from "@adornis/base/env-info.js";
import { Int } from "@adornis/baseql/baseqlTypes.js";
import { Arg, Entity, Field, Query } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { registerQuery } from "@adornis/baseql/metadata/register.js";
import { selectionSet } from "@adornis/baseql/utils/queryGeneration.js";
import { validate } from "@adornis/validation/decorators.js";
import { nonOptional } from "@adornis/validation/functions/nonOptional.js";
import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { getMailTemplateByTypeResolver } from "../server/resolver.js";
import { mailTemplateDefinitions } from "./mail-template-definition.js";
import { buildEmail } from "./templates.js";
var ColorConfig = class extends AdornisEntity {
};
ColorConfig._class = "MailColorConfig";
__decorateClass([
  Field((type) => String)
], ColorConfig.prototype, "wrapperBack", 2);
__decorateClass([
  Field((type) => String)
], ColorConfig.prototype, "mainBack", 2);
__decorateClass([
  Field((type) => String)
], ColorConfig.prototype, "mainBorder", 2);
__decorateClass([
  Field((type) => String)
], ColorConfig.prototype, "highlight", 2);
ColorConfig = __decorateClass([
  Entity()
], ColorConfig);
var LogoConfig = class extends AdornisEntity {
};
LogoConfig._class = "MailLogoConfig";
__decorateClass([
  Field((type) => String)
], LogoConfig.prototype, "src", 2);
__decorateClass([
  Field((type) => String)
], LogoConfig.prototype, "alt", 2);
__decorateClass([
  Field((type) => Int)
], LogoConfig.prototype, "width", 2);
__decorateClass([
  Field((type) => Int)
], LogoConfig.prototype, "padding", 2);
LogoConfig = __decorateClass([
  Entity()
], LogoConfig);
var MailTemplate = class extends MongoEntity {
  /** @deprecated use assembleMailTemplate */
  static async getAvailableVariables(emailType) {
    const definition = mailTemplateDefinitions[emailType];
    if (!definition)
      throw new Error("No definition found for email type: " + emailType);
    return definition.variables;
  }
  /** @deprecated use assembleMailTemplate */
  static async getAvailableAttachments(emailType) {
    const definition = mailTemplateDefinitions[emailType];
    if (!definition)
      throw new Error("No definition found for email type: " + emailType);
    return definition.attachments;
  }
  /** @deprecated use assembleMailTemplate */
  static getMailHint(emailType) {
    const definition = mailTemplateDefinitions[emailType];
    if (!definition)
      throw new Error("No definition found for email type: " + emailType);
    return definition.editorHint();
  }
  static getMailTemplateByType(emailType, scope) {
    return async (gqlFields) => {
      return getMailTemplateByTypeResolver(emailType, scope);
    };
  }
  /** @deprecated use assembleMailTemplate */
  static async generateMailContent(emailType, infos = {}) {
    if (!A.isServer)
      throw new Error("Only call this on the server!");
    const mailTemplate = await this.getMailTemplateByType(emailType)(selectionSet(() => MailTemplate, 1));
    return mailTemplate.generateMailContent(infos);
  }
  /** @deprecated use assembleMailTemplate */
  async generateMailContent(infos = {}) {
    const variables = await this.constructor.getAvailableVariables(this.emailType);
    const subject = replaceVariables(infos, variables, this.subject);
    const content = replaceVariables(infos, variables, this.content);
    const result = { subject, content };
    return result;
  }
  /** @deprecated use assembleMailTemplate */
  async buildEmail(infos = {}, buildMailOptions = {}) {
    if (!this.content)
      return null;
    const { content } = await this.generateMailContent(infos);
    const renderString = html`${unsafeHTML(content)}`;
    const footer = this.footer ? html`${unsafeHTML(this.footer)}` : buildMailOptions.footer ?? "";
    const buildOptions = {
      contents: renderString,
      ...this.constructor.buildMailOptions,
      ...buildMailOptions,
      footer
    };
    return buildEmail(buildOptions);
  }
  /** @deprecated use assembleMailTemplate */
  async buildSubject(infos = {}) {
    if (!this.subject)
      return null;
    const { subject } = await this.generateMailContent(infos);
    return subject;
  }
};
MailTemplate._class = "MailTemplate";
MailTemplate._collectionName = "mail-templates";
/** @deprecated use assembleMailTemplate */
MailTemplate.buildMailOptions = {};
__decorateClass([
  Field((type) => String)
], MailTemplate.prototype, "emailType", 2);
__decorateClass([
  Field((type) => String, { default: (v) => v ?? "default" })
], MailTemplate.prototype, "scope", 2);
__decorateClass([
  Field((type) => String, { default: (v) => v ?? "" })
], MailTemplate.prototype, "name", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String, { default: (v) => v ?? "" })
], MailTemplate.prototype, "content", 2);
__decorateClass([
  validate(nonOptional()),
  Field((type) => String, { default: (v) => v ?? "" })
], MailTemplate.prototype, "subject", 2);
__decorateClass([
  Field((type) => String)
], MailTemplate.prototype, "footer", 2);
__decorateClass([
  Field((type) => LogoConfig)
], MailTemplate.prototype, "logoConfig", 2);
__decorateClass([
  Field((type) => ColorConfig)
], MailTemplate.prototype, "colorConfig", 2);
__decorateClass([
  Field((type) => [String], { default: (v) => v ?? [] })
], MailTemplate.prototype, "activatedAttachments", 2);
__decorateClass([
  Query((type) => MailTemplate),
  __decorateParam(0, Arg("emailType", (type) => String)),
  __decorateParam(1, Arg("scope", (type) => String))
], MailTemplate, "getMailTemplateByType", 1);
MailTemplate = __decorateClass([
  Entity()
], MailTemplate);
var replaceVariables = (infos = {}, availableVariables, text) => {
  for (const v of availableVariables) {
    const reg = new RegExp(`\\{\\{${v}\\}\\}`, "g");
    text = text.replace(reg, infos[v] ?? "{{" + v + "}}");
  }
  return text;
};
var getMailTemplateByType = registerQuery({
  operationName: "getMailTemplateByType",
  type: (type) => MailTemplate,
  resolve: (emailType, scope) => async (gqlFields) => {
    return getMailTemplateByTypeResolver(emailType, scope);
  }
});
var assembleMailTemplate = ({
  template,
  infos = {},
  overrides = {},
  renderFunction = buildEmail
}) => {
  const definition = mailTemplateDefinitions[template.emailType];
  if (!definition)
    throw new Error("No definition found for email type: " + template.emailType);
  const variables = definition.variables;
  const subject = replaceVariables(infos, variables, template.subject);
  const content = replaceVariables(infos, variables, template.content);
  const renderString = html`${unsafeHTML(content)}`;
  const footer = template.footer ? html`${unsafeHTML(template.footer)}` : overrides.footer ?? "";
  const buildOptions = {
    title: subject,
    contents: renderString,
    logoConfig: template.logoConfig ?? void 0,
    colorConfig: template.colorConfig ?? void 0,
    ...overrides,
    footer
  };
  return { subject, content: renderFunction(buildOptions) };
};
export {
  ColorConfig,
  LogoConfig,
  MailTemplate,
  assembleMailTemplate,
  getMailTemplateByType,
  replaceVariables
};
